// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"yg","categoryName":"zg","categoryImage":"Ag","categoryContent":"Bg"};